import { withDisplayName } from '@hocs/with-display-name'
import {
  EnhancedButton,
  EnhancedLink,
} from '@ui/enhanced-components/enhanced-components'
import { getPath } from '@utils/get-path'
import { graphql } from 'gatsby'
import React from 'react'

const ContentfulCta: Utils.EntryFC<Queries.ContentfulCtaFragment> = ({
  content: { htmlId, text, type, variant, externalLink, internalLink },
  entryInspectorProps,
  fieldInspectorProps,
}) => {
  const href = getPath(internalLink) || externalLink || undefined

  switch (type) {
    case 'link': {
      return (
        <EnhancedLink
          {...entryInspectorProps()}
          {...fieldInspectorProps({ fieldId: 'text' })}
          className="!font-medium"
          href={href}
          id={htmlId}
        >
          {text}
        </EnhancedLink>
      )
    }

    case 'button': {
      return (
        <EnhancedButton
          {...entryInspectorProps()}
          {...fieldInspectorProps({ fieldId: 'text' })}
          href={href}
          id={htmlId}
          variant={variant === 'contained' ? 'primary' : 'secondary'}
        >
          {text}
        </EnhancedButton>
      )
    }

    default: {
      return <></>
    }
  }
}

export const query = graphql`
  fragment ContentfulCta on ContentfulCta {
    ...ContentfulEntry
    htmlId
    text
    type
    variant
    internalLink {
      ...ContentfulBlogTagLink
      ...ContentfulBlogArticleLink
      ...ContentfulDeprecatedPageLink
      ...ContentfulStaticPageLink
    }
    externalLink
  }
`

export default withDisplayName(ContentfulCta, 'ContentfulCta')
